import { render, staticRenderFns } from "./c_cascader.vue?vue&type=template&id=6b0ecbea&scoped=true"
import script from "./c_cascader.vue?vue&type=script&lang=js"
export * from "./c_cascader.vue?vue&type=script&lang=js"
import style0 from "./c_cascader.vue?vue&type=style&index=0&id=6b0ecbea&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0ecbea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b0ecbea')) {
      api.createRecord('6b0ecbea', component.options)
    } else {
      api.reload('6b0ecbea', component.options)
    }
    module.hot.accept("./c_cascader.vue?vue&type=template&id=6b0ecbea&scoped=true", function () {
      api.rerender('6b0ecbea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PageDiy/mobileConfigRight/c_cascader.vue"
export default component.exports